import { render, staticRenderFns } from "./EvaluationMethod.vue?vue&type=template&id=0ecec306&scoped=true"
import script from "./EvaluationMethod.vue?vue&type=script&lang=js"
export * from "./EvaluationMethod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecec306",
  null
  
)

export default component.exports